export const METHOD = { nakit: "Nakit", kredi_karti: "Kredi Kartı", havale: "Havale/EFT", cek: "Çek" };
export const CENTER = { genel: "Genel", servis: "Servis", satis: "Satış" };
export const CHART_COLORS = ["#1B4D3E", "#D97706", "#be123c", "#0e7490", "#7c2d12", "#4d7c0f", "#475569", "#a16207", "#065f46", "#9f1239", "#1e3a8a", "#78350f", "#334155"];
export const todayLocal = () => {
  const d = new Date();
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
};
